module.exports = __webpack_public_path__ + "static/media/BannerTitle.87f7b1b6.jpg";